// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__37I-4","notes":"Notes_notes__cZlGu"};